import {
	ApiUtils,
	_axios
} from '@/api/apiUtil.js';


const api = {
	getStandardsApi: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(  "https://bk1.ossjk.cn/win/online/tOnlineTrends/dev_stand", params, successCallback, failCallback,
			exceptionCallback);
	}
}
export default api;
